import React from 'react';
import css from './BottomSeperator.css';

const BottomSeperator = (props) => {
    const { showPreviewListingBtn } = props;
    return <div className={showPreviewListingBtn ? css.root : css.noViewBtn } />
};

export default BottomSeperator;
